<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >     
      <el-form-item label="选择状态"  prop="state">
        <el-select v-model="searchForm.state" placeholder="全部">
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="输入搜索" prop="keyword">
        <el-input
          v-model="searchForm.keyword"
          placeholder="请输入提交人姓名/手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="提交时间段">
        <el-date-picker
          v-model="range"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="rangeChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
    <div class="mgt-18">
      <el-button plain size="small" type="" >盘点</el-button >
    </div>
    <div class="data-container scroll-table">
      <!-- 库存盘点 -->
      <el-table :data="tableData"
                border
                class="mgt-18"
                style="width: 100%"
                @selection-change="tableSelectionChange">
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="index" label="序号" width="50"> </el-table-column>
        <el-table-column prop="customerName" label="申请人"> </el-table-column>
        <el-table-column prop="customerName" label="手机号"> </el-table-column>
        <el-table-column prop="customerName" label="原次品总数"> </el-table-column>
        <el-table-column prop="customerName" label="变更次品总数为"> </el-table-column>
        <el-table-column prop="customerName" label="原当前库存数"> </el-table-column>
        <el-table-column prop="customerName" label="变更当前库存数为"> </el-table-column>
        <el-table-column prop="customerName" label="提交时间"> </el-table-column>
        <el-table-column prop="customerName" label="状态"> </el-table-column>
        <el-table-column prop="customerStatus" label="操作">
          <template slot-scope="scope">
            <el-link v-if="scope.row.customerStatus==0" type="danger" :underline="false">禁用</el-link>
            <el-link v-if="scope.row.customerStatus==1" :underline="false">启用</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mgt-10 pd-0"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="searchForm.current"
                     :page-sizes="[10, 20, 30, 50]"
                     :page-size="searchForm.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="searchForm.totalCount">
      </el-pagination>
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        totalCount: 0,
        current: 1,
        size: 10,
        beginTime:'',
        endTime:'',
        keyword:'',
        state:'', //状态 0待审核 1审核通过 2审核失败
      },
      range:'',//时间范围
      tableData: [],
      tableSelection: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    rangeChange(e){
      this.searchForm.beginTime=e[0]
      this.searchForm.endTime=e[1]
    },
    handleSizeChange (v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange (v) {
      this.searchForm.current = v;
      this.query();
    },
    handleReset() {
      this.range='';
      this.$refs.searchForm.resetFields();
      this.search();
    },
    search() {
      if (this.searchForm.name) {
        this.tableData = this.tableData.filter(
          (e) => e.btnName.indexOf(this.searchForm.name) >= 0
        );
      } else {
        this.query();
      }
    },
    query() {
      //获取接口
      this.$api.stock
        .getHouseStockCheckList(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    add() {
      this.btnForm = {
        btnIcon: "",
        btnName: "",
        btnCode: "",
        sort: 0,
      };
      this.addORUpdateVisible = true;
    },
   
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.tableData.findIndex(
              (c) => c.btnCode == this.btnForm.btnCode
            ) >= 0
          ) {
            this.$message.error("code不能重复");
            return;
          }
          if (this.funTit == "add") {
            this.$api.system
              .btnadd(this.btnForm)
              .then((d) => {
                if (d.code == 200) {
                  this.addORUpdateVisible = false;
                  this.$refs.btnForm.resetFields();
                  this.btnlist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            this.$api.system
              .btnupdate(this.btnForm)
              .then((d) => {
                if (d.code == 200) {
                  this.addORUpdateVisible = false;
                  this.$refs.btnForm.resetFields();
                  this.btnlist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>